import React from "react";
import PCMSDashboard from "@components/PCMS/PCMSDashboard";
import { PageHeader } from "@features/shared";

/**
 * PCMS Page
 * Displays PCMS dashboard iframe
 */
const PCMSPage = () => {
  return (
    <>
      <PageHeader title="PCMS" path="/" />
      <PCMSDashboard />
    </>
  );
};

export default PCMSPage;
